import { render, staticRenderFns } from "./OrdersIndexView.vue?vue&type=template&id=249f509b&"
import script from "./OrdersIndexView.vue?vue&type=script&lang=js&"
export * from "./OrdersIndexView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports